

import {
  FaFacebookF,
  FaInstagram,
  FaSnapchatGhost,
  FaTiktok,
  FaWhatsapp,
  FaPhoneAlt,
  FaEnvelope
} from "react-icons/fa";

export default function Contact() {
  return (
    <div className="contact-page">

      {/* HEADER */}
      <div className="contact-header">
        <h1>Contact Us</h1>
        <p>
          Get in touch with Jumeirah Chauffeuring for bookings and inquiries.
        </p>
      </div>

      {/* CONTACT GRID */}
      <div className="contact-grid">
      <div className="contact-card">
        <h3>Phone</h3>

        <a
          href="tel:+447826699446"
          className="contact-link"
        >
          <FaPhoneAlt className="contact-link-icon" />
          <span>0047826699446</span>
        </a>
      </div>

        <div className="contact-card">
          <h3>WhatsApp</h3>
          <a
            className="whatsapp-btn"
            href="https://wa.me/447826699446?text=Hello%2C%20I%20am%20interested%20in%20your%20luxury%20chauffeur%20services"
            target="_blank"
            rel="noreferrer"
          >
            <FaWhatsapp className="contact-whatsapp-icon" />            
            <span>Chat on WhatsApp</span>
          </a>
        </div>

        <div className="contact-card">
          <h3>Email</h3>

          <a
            href="mailto:jumeirahjc@gmail.com"
            className="contact-link"
          >
            <FaEnvelope className="contact-link-icon" />
            <span>jumeirahjc@gmail.com</span>
          </a>
        </div>

      </div>

      {/* SOCIAL MEDIA */}
      <div className="contact-social-section">

        <h2>Follow Us</h2>

          <div className="contact-social">

            <a
              href="https://www.facebook.com/people/Jumeirah-Chauffeuring/61586141420211/"
              target="_blank"
              rel="noreferrer"
            >
              <FaFacebookF />
              <span>Facebook</span>
            </a>

            <a
              href="https://www.instagram.com/jumeirahjc"
              target="_blank"
              rel="noreferrer"
            >
              <FaInstagram />
              <span>Instagram</span>
            </a>

            <a
              href="https://www.snapchat.com/@jumeirahjc"
              target="_blank"
              rel="noreferrer"
            >
              <FaSnapchatGhost />
              <span>Snapchat</span>
            </a>

            <a
              href="https://www.tiktok.com/@jumeirah_jc"
              target="_blank"
              rel="noreferrer"
            >
              <FaTiktok />
              <span>TikTok</span>
            </a>

          </div>
      </div>

      {/* MAP SECTION */}
      <div className="contact-map">
        <h2>Our Location</h2>

        <iframe
          title="location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d317719.5878308294!2d-0.43123578679563057!3d51.528179783661116!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8a00baf21de75%3A0x52963a5addd52a99!2sLondon%2C%20UK!5e0!3m2!1sen!2seg!4v1778024685933!5m2!1sen!2seg"
          loading="lazy"
        ></iframe>
      </div>

    </div>
  );
}